import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { finalize } from 'rxjs';
import { TipuriTaxeNedebitabileService } from 'src/app/components/tipuri-taxe-nedebitate/tipuri-taxe-nedebitabile.service';
import { NotificationService } from 'src/app/services/notification.service';
import { environment } from 'src/environments/environment';
import { helper } from 'src/environments/helper';

@Component({
  selector: 'app-edit-tipuri-taxe-nedebitate',
  templateUrl: './edit-tipuri-taxe-nedebitate.component.html',
  styleUrls: ['./edit-tipuri-taxe-nedebitate.component.scss'],
})
export class EditTipuriTaxeNedebitateComponent implements OnInit {
  errorTitle: string = helper.dialogConfig.headers.errorAtentie;
  errorIcon: string = helper.dialogConfig.icons.error;
  errorType: string = helper.dialogConfig.icons.error;

  helper = helper;

  token!: string;
  isLoading = false;

  form!: FormGroup;

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: any,
    private dialogRef: MatDialogRef<EditTipuriTaxeNedebitateComponent>,
    private tipuriTaxeNedebitabileService: TipuriTaxeNedebitabileService,
    private notificationService: NotificationService
  ) {}

  closeDialog() {
    this.dialogRef?.close({
      success: false,
    });
  }

  ngOnInit(): void {
    this.buildForm();
  }

  buildForm() {
    this.form = new FormGroup({
      necesita_suma_de_introdus: new FormControl(
        this.data.necesita_suma_de_introdus,
        Validators.required
      ),
      web_name: new FormControl(this.data.web_name, Validators.required),
      valoareImplicita: new FormControl(
        this.data.valoareImplicita,
        Validators.required
      ),
      observatii: new FormControl(this.data.observatii, Validators.required),
    });
  }

  submitForm() {
    this.isLoading = true;

    const data = {
      id: this.data.id,
      necesita_suma_de_introdus: this.form.get('necesita_suma_de_introdus')
        ?.value,
        web_name: this.form.get('web_name')?.value,
      valoareImplicita: this.form.get('valoareImplicita')?.value,
      observatii: this.form.get('observatii')?.value,
    };
    this.tipuriTaxeNedebitabileService
      .updateTaxeNedebitate(data)
      .pipe(finalize(() => (this.isLoading = false)))
      .subscribe({
        next: () => {
          this.dialogRef.close({ success: true });
        },
        error: () => {
          let errorMessage =
            environment.config.customNotifications.generalMessages.error;
          this.notificationService.warningSwal(
            this.errorTitle,
            errorMessage,
            this.errorIcon
          );
        },
      });
  }
}
